class DateScreenerCriteria extends Tango.Component {
    widgetDidMount() {
        this._bind();
    }
    widgetContentChanged() {
        this._bind();
    }

    _bind() {
        const root = document.getElementById(this.root);
        if (!root) return;

        const opSelect = root.querySelector('select[name="op"]');
        const category = opSelect.dataset.category;
        if (opSelect) {
            opSelect.addEventListener('change', () => {
                if (this._opCategory(opSelect.value) !== category) {
                    ajaxUtils.postEventFromElementWithApiResponse(opSelect);
                }
            });
        }

        root.querySelectorAll('input[type=radio][data-toggle-date]').forEach(radio => {
            radio.addEventListener('change', () => {
                if (!radio.checked) return;
                this._applyMode(radio);
            });
        });

        root.querySelectorAll('select[data-toggle-shift]').forEach(sign => {
            sign.addEventListener('change', () => this._applyShift(sign));
        });
    }

    _opCategory(v) {
        if (v === 'between') return 'range';
        if (v === 'inshortcut') return 'shortcut';
        return 'single';
    }

    _applyMode(radio) {
        const dateEl = document.getElementById(radio.dataset.toggleDate);
        const exprEl = document.getElementById(radio.dataset.toggleExpr);
        const isDate = radio.value === 'date';
        if (dateEl) dateEl.style.display = isDate ? 'flex' : 'none';
        if (exprEl) exprEl.style.display = isDate ? 'none' : 'flex';
    }

    _applyShift(sign) {
        const block = document.getElementById(sign.dataset.toggleShift);
        if (block) block.style.display = sign.value === '' ? 'none' : 'flex';
    }
}

Tango.registerComponent(DateScreenerCriteria);
